import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { from, Observable, of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators'
import { AppService } from 'src/app/app.service';
import { get as _get, includes as _includes } from 'lodash';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private appService : AppService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if(!_includes(request.url, 'verifyfiretoken') && !request.headers.get("skip")) {
      return from(this.appService.returnRefreshToken())
      .pipe(
        switchMap(tokenObject => {
          const headers = request.headers.set('Authorization', 'Bearer ' + _get(tokenObject, 'token'))
          const requestClone = request.clone({
            headers
          });
          return next.handle(requestClone);
        }),
        catchError(error => {
          console.log(error)
          if(_includes(request.url, 'services/status')) {
            return next.handle(request)
          } 
          return throwError(error)
        })
       );
    } else {
      return next.handle(request);
    }
  }
}
